import Vue from 'vue';
import ThematicBlockRenault from '../common/vue-components/ThematicBlockRenault';

export default function initThematicBlock() {
  const $container = document.querySelector('.cp-thematic-blocks-renault');

  if (!$container) {
    return;
  }

  new Vue({
    el: $container,

    data: {},

    components: {
      ThematicBlockRenault,
    },
  });
}
